let list = {
  state: {
    list: [
    // '54284433660000012'
    ]
  },
  mutations: {
    initOrderData(state, data) {
      state.list = data;
    },
    addOrderData(state, data) {
      let index = state.list.indexOf(data);
      if (index < 0) {
        state.list.push(data);
      }
    },
    deleOrderData(state, data) {
      let index = state.list.indexOf(data);
      state.list.splice(index, 1);
    }
  }
}
export default list



// WEBPACK FOOTER //
// ./src/store/orderList.js